import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { VatReportPayload } from 'app/types/reports/vat'

export const createVatReport = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.vat.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = VatReportPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
